import { render, staticRenderFns } from "./category-expand-filter.vue?vue&type=template&id=bb2e9e94&"
import script from "./category-expand-filter.vue.ts?vue&type=script&lang=ts&"
export * from "./category-expand-filter.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports